import {
  boxColorComposition,
  DetailColorId,
  isLightColor,
} from '@aboutyou/legacy-shared/src/utils/detailColor'
import React, { ChangeEvent, CSSProperties, FC } from 'react'

import Checkbox from 'uiComponents/atoms/Checkbox/Checkbox'

const getBoxColorComposition = ({
  colorId,
}: {
  colorId: DetailColorId
}): CSSProperties | undefined => {
  const boxColorObject = boxColorComposition(colorId)
  if (!boxColorObject) {
    return undefined
  }

  if (boxColorObject.colorType === 'constant') {
    return {
      backgroundColor: boxColorObject.colorPattern,
      boxShadow: `inset 0 0 0 2px ${boxColorObject.borderColor}`,
    }
  }

  if (boxColorObject.colorType === 'gradient') {
    return {
      backgroundImage: boxColorObject.colorPattern,
      boxShadow: 'none',
    }
  }

  return {
    background: boxColorObject.colorPattern,
    backgroundSize: '50% 50%',
    backgroundPosition: '0 0, 0 100%, 100% 0, 100% 100%',
    backgroundRepeat: 'no-repeat',
    boxShadow: 'none',
  }
}

interface IColorCheckboxProps {
  checked: boolean
  colorId: DetailColorId
  id?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

const ColorCheckbox: FC<IColorCheckboxProps> = ({
  checked = false,
  colorId,
  id,
  onChange = () => undefined,
}) => {
  return (
    <Checkbox
      checked={checked}
      checkboxStyle={getBoxColorComposition({ colorId })}
      checkMarkColor={isLightColor(colorId) ? 'black' : 'white'}
      id={id}
      onChange={onChange}
    />
  )
}

export default ColorCheckbox
